
import { Component, Prop, Vue, Watch } from "vue-property-decorator"

import DefinitionTitle from "@/components/Config/Definitions/DefinitionTitle.vue"
import { evaluate } from "mathjs"
import HelpIcon from "@/components/New/Page/PageComponents/HelpIcon.vue"

@Component({
	components: {
		HelpIcon,
		"definition-title": DefinitionTitle
	}
})
export default class CalculationExpression extends Vue {
	@Prop({ default: "" })
	value!: string

	@Prop({ default: "" })
	calculationTitle!: string

	private get expression (): string {
		return this.value ? this.value : ""
	}

	private set expression (value: string) {
		this.$emit("input", value)
	}

	private get insightsCalculationField (): any[] {
		return [{
			field: {
				id: "value",
				title: "Value"
			}
		}]
	}

	private get isValidMathExpression (): boolean {
		if (!this.expression) {
			return true
		}
		// Replace placeholder value with a number for checks
		var expressionString = this.expression.replace("{" + this.calculationTitle + "}", "1").replace("{value}", "1")

		if (expressionString.match(/[a-z]/i)) {
			return false
		}

		try {
			var evaluated = evaluate(expressionString)

			// If calculation is Invalid, e.g dividing by zero
			if (evaluated === Infinity) {
				return false
			}
			return true
		} catch (e) {
			return false
		}
	}
}
